module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/674f50d287a8c48dc19ba404d20fe713.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0
// module id = 260
// module chunks = 4